// components/SingleSelectAdd.js
import React, { useEffect } from 'react';
import { Grid, Typography } from '@mui/material';
import { makeStyles } from '@material-ui/core';
import CustomTextField from '../../shared/CustomTextField';
import CustomPopupText from '../../shared/CustomPopupText';
import CustomPicker from '../../shared/CustomPicker';
import CustomUploadField from '../../shared/CustomUploadField';
import CustomDropDown from '../../shared/CustomDropDown';
import MultiSelectSearch from '../../common/search/MultiSelectSearch';
import useFetchData from '../hooks/useFetchData';
import CustomGroupCheckbox from '../../shared/CustomGroupCheckbox';
import { visibility } from '../constants';
import { DIMENSIONS } from '../../../constants/aspectRatio';

const useStyles = makeStyles({
  publishDateField: {
    height: '44px',
    padding: '0px 12px',
    fontSize: '12px',
    margin: '12px 0px',
    border: '1px solid rgba(228, 231, 236, 1)',
    borderRadius: '8px',
    background: 'rgba(254, 254, 254, 1)',
  },
});

const SeriesInfo = ({
  data,
  handleDateChange,
  handleData,
  thumbnailImg,
  handleThumbnailUpload,
  handleMultiSelect,
  planList,
}) => {
  const classes = useStyles();
  const { getRnp, partners } = useFetchData();

  useEffect(() => {
    getRnp();
  }, [getRnp]);

  return (
    <Grid container direction="column" spacing={4}>
      <Grid item>
        <Grid container direction="column">
          <Grid item>
            <Grid container direction="row" spacing={2}>
              <Grid item xs={6}>
                <CustomPopupText text="Quiz Series Name" required />
                <CustomTextField
                  placeholder="Enter quiz series name"
                  value={data?.name}
                  handleChange={handleData}
                  name="name"
                  width="100%"
                />
              </Grid>
              <Grid item xs={6}>
                <CustomPopupText text="Cover Image (max size - 100kb)" required />
                <CustomUploadField
                  type="image"
                  name="thumbnail"
                  value={thumbnailImg}
                  imgSrc={data?.thumbnail}
                  handleChange={handleThumbnailUpload}
                  customStyles={{ height: '44px', width: '482px' }}
                  dimensions={DIMENSIONS.quizCoverImage}
                />
              </Grid>
            </Grid>
          </Grid>
          <Grid item>
            <Grid container direction="row">
              <Grid item xs={6}>
                <CustomPopupText text="Start Date" required />
                <CustomPicker
                  name="startDate"
                  data={data}
                  handleDateChange={handleDateChange}
                  customStyles={classes.publishDateField}
                />
              </Grid>
              <Grid item xs={6}>
                <CustomPopupText text="End Date" required />
                <CustomPicker
                  name="endDate"
                  data={data}
                  handleDateChange={handleDateChange}
                  customStyles={classes.publishDateField}
                />
              </Grid>
            </Grid>
          </Grid>
          <Grid item>
            <Grid container direction="row" spacing={2}>
              <Grid item xs={6}>
                <CustomPopupText text="Plans" required />
                <div style={{ marginTop: '13px' }}>
                  <MultiSelectSearch
                    name="plan"
                    placeholderButtonLabel="Select a Plan"
                    selectedOptions={data?.plans}
                    onChange={handleMultiSelect}
                    options={planList || []}
                    width="100%"
                    maxMenuHeight={150}
                    labelWidth="270px"
                    white
                    showValue
                  />
                </div>
              </Grid>
              <Grid item xs={6}>
                <CustomPopupText text="Partner" required />
                <CustomDropDown
                  name="partners"
                  width="100%"
                  list={partners?.map((i) => ({ id: i.id, title: i.name }))}
                  handleChange={handleData}
                  value={partners?.find((p) => p.id === data?.partners)?.name}
                />
              </Grid>
            </Grid>
          </Grid>
          <Grid item style={{ height: '60px' }}>
            <Grid container direction="row" spacing={2}>
              <Grid item xs={6}></Grid>
              <Grid item xs={6}>
                <Grid container direction="row" alignItems="center" spacing={2}>
                  <Grid item>
                    <CustomPopupText text="Quiz Visibility :" />
                  </Grid>
                  <Grid item>
                    <CustomGroupCheckbox
                      data={data}
                      handleChange={handleData}
                      name="visibility"
                      options={visibility}
                      disabledOptions={['DEALERSHIP']}
                    />
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
          <Grid item>
            <Grid container direction="row" spacing={2}>
              <Grid item xs={6}>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                  <CustomPopupText text="Quiz Reporting Code" />
                  <Typography style={{ color: '#667085', fontSize: '14px' }}>
                    {`${data?.courseCode?.length || 0}/10`}
                  </Typography>
                </div>

                <CustomTextField
                  placeholder="ex: 12345"
                  value={data?.courseCode}
                  handleChange={handleData}
                  name="courseCode"
                  width="100%"
                />
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default SeriesInfo;
